import * as React from 'react';
import Site from "../../../model/site/Site";

interface ReduxProps {
	/**
	 * All sites.
	 */
	sites: Site[];
}

export default class SitesTable extends React.Component<ReduxProps, {}> {
	render() {
		return (
			<table className="l-table-default table-hover">
				<thead>
				<tr>
					<th>Street</th>
					<th>Town</th>
					<th>Postcode</th>
					<th>Country</th>
				</tr>
				</thead>
				<tbody>
				{this.props.sites.map((site, index) =>
					<tr key={index}>
						<td>{site.data.address.displayStreet()}</td>
						<td>{site.data.address.city.getOrElse("")}</td>
						<td>{site.data.address.postcode}</td>
						<td>{site.data.address.country}</td>
					</tr>)
				}
				</tbody>
			</table>
		);
	}
}